export default function brightspotSocialHelper(platformsToFind, pageData) {
  if (!platformsToFind || !pageData) return null
  const socialPlatforms = []

  platformsToFind.forEach((platform) => {
    const socialPlatform = pageData?.[platform]?.url
      ? {
          platform,
          url: pageData?.[platform].url,
        }
      : null

    if (socialPlatform) {
      socialPlatforms.push(socialPlatform)
    }
  })

  return socialPlatforms
}

export const _ = {}
